import { useTranslation } from 'react-i18next'
import { useTheme } from '@mui/material'
import { Thermostat } from '@mui/icons-material'
import AuroraAssetGroupTargetTemperatureControl from './AuroraAssetGroupTargetTemperatureControl'
import AuroraControlGroup from './AuroraControlGroup'
import { AuroraAssetGroup } from '../types'

interface AuroraAssetGroupTemperatureControlsProps {
  auroraAssetGroup: AuroraAssetGroup
}

export default function AuroraAssetGroupTemperatureControls({
  auroraAssetGroup
}: AuroraAssetGroupTemperatureControlsProps) {
  const { t } = useTranslation('aurora')

  const theme = useTheme()

  return (
    <AuroraControlGroup
      label={t('temperatureControl')}
      icon={<Thermostat htmlColor={theme.palette.text.secondary} />}
    >
      <AuroraAssetGroupTargetTemperatureControl auroraAssetGroup={auroraAssetGroup} />
    </AuroraControlGroup>
  )
}
